import { render, staticRenderFns } from "./TemplateSetting.vue?vue&type=template&id=4a60b870"
import script from "./TemplateSetting.vue?vue&type=script&lang=js"
export * from "./TemplateSetting.vue?vue&type=script&lang=js"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports